<div class="main-content d-flex">
  <div class="sidebar ps-2 pe-2 vh-100 py-3 top-0 bottom-0" [class.active]="sidebarOpen">
    <div class="side-toogle-div d-flex justify-content-center">
      <button class="side-toogle bg-transparent border-0" (click)="toggleSidebar()">
        @if (sidebarOpen) {
          <i class="das das-hamburgericon text-white fs-14"></i>
        }
        @if (!sidebarOpen) {
          <i class="das das-cross text-white fs-14"></i>
        }
      </button>
    </div>
    <educare-navigation [isCollapsed]="sidebarOpen" (expandRequested)="sidebarOpen = false"></educare-navigation>
  </div>
  <div class="main-data" [class.mainactive]="sidebarOpen">
    <div class="inner-content">
      <div class="container-fluid">
        <educare-header></educare-header>
        <section>
          <router-outlet></router-outlet>
        </section>
      </div>
    </div>
  </div>

  <!-- Face Scanner Component -->
  <educare-face-scan
    *ngIf="showFaceScanner"
    [isVisible]="showFaceScanner"
    [isSidebarCollapsed]="sidebarOpen"
    (closeRequested)="onFaceScanCloseRequested()"
    (screenLocked)="onScreenLocked()"
  >
  </educare-face-scan>
</div>
